import { Avatar } from '@mui/material';
import React from 'react';


const CircularImage = ({ imageUrl, radius ,sx}) => {
  const avatarStyle = {
    width: `${radius}px`,
    height: `${radius}px`,
  };

  return (
    <Avatar alt="Circular" src={imageUrl} sx={sx??null} style={avatarStyle} />
  );
};

export default CircularImage;
